/**
 * Extracts the build identifier from the `<meta name="app-build">` tag that
 * buildMetaPlugin (vite.config.ts) injects into index.html. This tag is the
 * authoritative "which build is actually being served" signal used by the
 * version monitor — see src/lib/version-monitor.ts for why the CloudFront
 * `x-app-version` header can't be trusted for this on its own.
 *
 * Returns null when the tag is absent (e.g. an older pre-meta bundle is
 * still being served mid-deploy, which correctly reads as "the new bundle
 * isn't live yet") or malformed. Tolerant of attribute ordering and of
 * single- or double-quoted values.
 */
export function parseBuildFromHtml(html: string): string | null {
  const tag = html.match(/<meta[^>]*\bname=["']app-build["'][^>]*>/i)?.[0];
  return tag?.match(/\bcontent=["']([^"']+)["']/i)?.[1] ?? null;
}
